import Vue from 'vue';
import Vuex from 'vuex';
import language from './modules/language'
import preference from './modules/preference'
import auth from './modules/auth';
import feed from './modules/feed';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        language,
        preference,
        auth,
        feed,
    },
});